import { injectStyle } from '@edicom/common/tool/injectStyle';
import { invalidCache } from './cssVariablesGetter';

/**
 * Injecta el css en la pagina.
 * Se encarga de invalidar la cache de las variables css.
 *
 * @param {string} css el css en texto
 * @param {string} [name] se pondrá el `name` como id del elemento <style>, y lo actualizara si ya existe
 * @param {object} [options]
 */
export async function updateCss(css, name, options) {
  invalidCache();
  return injectStyle(css, name, options);
}
